import { Coordinate, Trip } from "@fairfleet/geotab";
import Skeleton from "@mui/material/Skeleton";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { usePreviousTrip } from "../../../hooks/usePreviousTrip";
import { useAddresses } from "@/hooks/addresses/useAddresses";

export function StartAddressCell(props: GridRenderCellParams<Trip>) {
  const { data: prev } = usePreviousTrip(props.row);
  const { data: addresses, isLoading } = useAddresses(
    prev?.stopPoint ? [prev.stopPoint as Coordinate] : [],
  );

  if (isLoading || !addresses) {
    return <Skeleton width="100%" variant="text" />;
  }

  return <>{addresses[0]?.formattedAddress}</>;
}
